import { destroy, get, post } from "./utils/requests"
import { CampProps } from "~/interfaces"

const fetchTerminalReaders = (camp_id: string) => get(`/api/terminal/${camp_id}`)

const processPayment = (camp_id: string, payment_intent_id: string, reader_id: string) =>
  post("/api/terminal/process_payment", { camp_id, payment_intent_id, reader_id })

const cancelCurrentPayment = (camp_id: string, payment_intent_id?: string, reader_id?: string) => {
  const savedReaderId = reader_id || localStorage.getItem(`park_terminal_reader_${camp_id}`)
  return destroy("/api/terminal/cancel_current_payment", { camp_id, payment_intent_id, reader_id: savedReaderId })
}

const checkPaymentStatus = (camp_id: string, payment_intent_id: string, reader_id?: string) =>
  post("/api/terminal/check_payment_status", { camp_id, payment_intent_id, reader_id })

const capturePaymentIntent = (camp_id: string, payment_intent_id: string) =>
  post("/api/terminal/capture_payment_intent", { camp_id, payment_intent_id })

const Terminal = {
  fetchTerminalReaders,
  processPayment,
  cancelCurrentPayment,
  capturePaymentIntent,
  checkPaymentStatus,
}

export default Terminal
